import DataContainer from "../../services/DataContainer";
import { Logo } from "../../components/Logo/Logo";

export type PowerType = "Electric" | "Diesel" | "Gaspowered";

type Props = {
  availablePowerTypes: PowerType[];
  selectedPowerType: PowerType;
  onPowerTypeSelect: (type: PowerType) => void;
};

export const TruckSelectorHeader = ({
  availablePowerTypes,
  selectedPowerType,
  onPowerTypeSelect,
}: Props) => {
  return (
    <div className="w-full border-b xxl:border-none px-4 xxl:px-20 pt-[env(safe-area-inset-top,0px)]">
      <div className="relative flex items-center justify-center">
        <div className="absolute left-0">
          <Logo />
        </div>
        <nav className="flex justify-center gap-8 xxl:gap-0">
          {availablePowerTypes.map((type) => (
            <button
              key={type}
              onClick={() => onPowerTypeSelect(type)}
              className={`flex-1 max-w-fit px-0 xxl:px-8 py-4 text-base font-normal transition-all duration-300 border-b-2 ${
                selectedPowerType === type
                  ? "text-[#212121] border-[#212121]"
                  : "text-[#575757] border-transparent hover:text-[#212121] hover:border-gray-400"
              }`}
            >
              {DataContainer.sectionKey(
                "TruckSelector",
                `category_${type.toLocaleLowerCase()}`,
              )}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};
